/**
 * @generated SignedSource<<2c628f34eec96e13a5ef1db817560c70>>
 * @relayHash 3ff9796e1e38cb4ca9e4d57e39767c41
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3ff9796e1e38cb4ca9e4d57e39767c41

import { ConcreteRequest } from 'relay-runtime';
export type ContactChannel = "APP" | "EMAIL_AND_SMS" | "NO_CHANNEL";
export type Country = "CH" | "DE";
export type Gender = "FEMALE" | "MALE" | "OTHER" | "UNKNOWN";
export type chDuplicatePatientByIdQuery$variables = {
  patientId: string;
};
export type chDuplicatePatientByIdQuery$data = {
  readonly ch_patientById: {
    readonly contactChannel: ContactChannel;
    readonly country: Country;
    readonly displayId: number;
    readonly duplicatePatients: ReadonlyArray<{
      readonly contactChannel: ContactChannel;
      readonly displayId: number;
      readonly firstName: string;
      readonly gender: Gender;
      readonly id: string;
      readonly lastName: string;
    }>;
    readonly firstName: string;
    readonly gender: Gender;
    readonly id: string;
    readonly lastName: string;
  } | null;
};
export type chDuplicatePatientByIdQuery = {
  response: chDuplicatePatientByIdQuery$data;
  variables: chDuplicatePatientByIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "patientId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gender",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contactChannel",
  "storageKey": null
},
v7 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "patientId"
      }
    ],
    "concreteType": "ch_Patient",
    "kind": "LinkedField",
    "name": "ch_patientById",
    "plural": false,
    "selections": [
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/),
      (v4/*:: as any*/),
      (v5/*:: as any*/),
      (v6/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "country",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DuplicatePatientOutput",
        "kind": "LinkedField",
        "name": "duplicatePatients",
        "plural": true,
        "selections": [
          (v1/*:: as any*/),
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          (v5/*:: as any*/),
          (v6/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "chDuplicatePatientByIdQuery",
    "selections": (v7/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "chDuplicatePatientByIdQuery",
    "selections": (v7/*:: as any*/)
  },
  "params": {
    "id": "3ff9796e1e38cb4ca9e4d57e39767c41",
    "metadata": {},
    "name": "chDuplicatePatientByIdQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "190e444110f05bbfcd1939ad83b0764b";

export default node;
